<template>
    <div>
        <label> <slot> Incidents: </slot></label>
        <Button class="mt-2" :label="buttonLabel" @click="toggleDialog(true)" />
        <IncidentsSelectionDialog v-if="dialogForm" @incident-selected="incidentsSelected" @hide-dialog="toggleDialog(false)" />
    </div>
</template>

<script setup>

import { ref, computed, watch, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';

import { incidentStore } from '@/store/global-stores';
import IncidentsSelectionDialog from '@/modules/user/components/IncidentsSelectionDialog.vue';

const emit = defineEmits(['update:modelValue', 'incident-selected']);

const props = defineProps({
    modelValue: Array,
});

// Store states
const { activePanelIncidents } = storeToRefs(incidentStore);

// Component states
const dialogForm = ref(false);

// Computed properties
const buttonLabel = computed(() => {
    return activePanelIncidents.value?.length > 0 ? `${activePanelIncidents.value?.length} incident number selected` : 'Select Incidents numbers';
});

watch(
    () => props.modelValue,
    () => {
        // If it means that the modelValue have been cleared so this needs reflection on overall components states as well
        if (props.modelValue?.length <= 0) {
            // We will just clear off the activePanelIncidents information here directly
            cleanPanelUsers();
        }
    }
);

// When the panel unmounts, make sure to clean the cache information regarding activePanelIncidents
onUnmounted(() => {
    cleanPanelUsers();
});

// Toggles dialog form
const toggleDialog = (flag) => {
    dialogForm.value = flag;
};

const incidentsSelected = (incidentIds) => {
    emit('incident-selected', incidentIds);
};

const cleanPanelUsers = () => {
    activePanelIncidents.value = [];
};
</script>
